<template>
  <div class="personal">
    <div style="margin-top:2rem">
      <el-avatar :size="50" :src="getImageURL(user.avatar)"></el-avatar>
      <div>{{user.username}}</div>
    </div>
    <div class="history">
      <div class="historyTitle">
        <span style="font-size:1.5rem">观看历史</span>
        <span style="color:#c8c8c8">更多</span>
      </div>
      <div></div>
    </div>
    <div class="moduleList">
      <div class="moduleDetail">
        <img src="@/assets/img/personal/icon_usercenter_msg.png" style="width:2rem" />
        <div>我的消息</div>
      </div>
      <div class="moduleDetail">
        <img src="@/assets/img/personal/icon_usercenter_preorder.png" style="width:2rem" />
        <div>我的预约</div>
      </div>
      <div class="moduleDetail">
        <img src="@/assets/img/personal/icon_usercenter_video.png" style="width:2rem" />
        <div>视频管理</div>
      </div>
      <div class="moduleDetail">
        <img src="@/assets/img/personal/icon_usercenter_collection.png" style="width:2rem" />
        <div>我的收藏</div>
      </div>
      <div class="moduleDetail">
        <img src="@/assets/img/personal/icon_usercenter_wallet.png" style="width:2rem" />
        <div>我的钱包</div>
      </div>
      <div class="moduleDetail">
        <img src="@/assets/img/personal/icon_usercenter_comment.png" style="width:2rem" />
        <div>评论管理</div>
      </div>
      <div class="moduleDetail">
        <img src="@/assets/img/personal/icon_usercenter_about.png" style="width:2rem" />
        <div>关于我们</div>
      </div>
    </div>
  </div>
</template>
<script>
import { getImageURL } from "@/utils/zgly-utils.js";
export default {
  data() {
    return {
      VUE_APP_BASE_API: process.env.VUE_APP_BASE_API,
      user: {
        avatar: ""
      }
    };
  },
  created() {
    // this.user = JSON.parse(window.localStorage.getItem("user"));
  },
  methods: {
    getImageURL(cover) {
      return getImageURL(cover);
    }
  }
};
</script>
<style lang="less" scoped>
.personal {
  margin: 0px 1rem;
  .history {
    margin: 1rem 0rem;
    padding: 1rem 0rem;
    border-top: 1px solid #c8c8c8;
    border-bottom: 1px solid #c8c8c8;
    .historyTitle {
      display: flex;
      justify-content: space-between;
    }
  }
  .moduleList {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    .moduleDetail {
      display: flex;
      width: 33%;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      margin-top: 1rem;
    }
  }
}
</style>